import type { Brand } from '@/domainLogic/index.ts';
import { useTranslation } from '@/app/components/translations/Translation';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import OpenXModal from '../../../search/components/Modal/OpenXModal';
import ModalHeader from '../../../search/components/Modal/LayoutElements/ModalHeader';
import { EvoRoomCancellationInformation } from './EvoRoomCancellationInformation';

type EvoRoomCancellationInformationModalProps = {
  id: string;
  // Every meal plan type of the room — the modal always shows the cancellation fees for all of them.
  mealPlans: readonly MealPlanType[];
  isOpen: boolean | undefined;
  onDismiss: () => void;
  onOpenByBrowserHistory?: () => void;
};

export function EvoRoomCancellationInformationModal(props: EvoRoomCancellationInformationModalProps) {
  const { id, mealPlans, isOpen, onDismiss, onOpenByBrowserHistory } = props;
  const { t } = useTranslation();
  const { staticData, commonData, localization } = usePageWrapperData();
  const isMobile = commonData.isMobileDevice;

  return (
    <OpenXModal
      isOpen={isOpen ?? false}
      isMobile={isMobile ?? true}
      brand={staticData.domainValues?.brand as Brand}
      onClose={onDismiss}
      onCloseByBrowserHistory={onDismiss}
      onOpenByBrowserHistory={onOpenByBrowserHistory}
      fullScreen={false}
      id={`taxes-modal-${id}`}
      aria-label={t('vacation.select.room_panel.cancellation')}
      bodyBackgroundColor="backgroundLayer02"
      scrollShadows={localization?.configValuesApp?.evolutionEnabled}
      header={{
        sticky: true,
        element: <ModalHeader handleClose={onDismiss}>{t('vacation.select.room_panel.cancellation')}</ModalHeader>,
      }}
    >
      <EvoRoomCancellationInformation mealPlans={mealPlans} />
    </OpenXModal>
  );
}
